import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "../../app";
import { ITextVertex } from "../../annotator/interfaces/textLayer";
import selectAnnotationReducer from "./annotationReducerSelector";
import { getAvailableTokens } from "../utils/utils";

export interface ITextLayerForPage {
  text: string;
  tokens: Array<ITextVertex>;
}

type Props = {
  page: number;
  excludeTokensOfEntityId: string | null;
  excludeTokensOfIndex: number | undefined;
};

const getPdf = (state: RootState) => state.documentReducer.pdf;
const getPage = (_: RootState, props: Props) => props.page;
const getExcludeTokensOfEntityId = (_: RootState, props: Props) =>
  props.excludeTokensOfEntityId;
const getExcludeTokensOfIndex = (_: RootState, props: Props) =>
  props.excludeTokensOfIndex;

const textLayerForPageSelector = createSelector(
  [
    getPdf,
    getPage,
    selectAnnotationReducer,
    getExcludeTokensOfEntityId,
    getExcludeTokensOfIndex,
  ],
  (
    pdf,
    page,
    annotations,
    excludeTokensOfEntityId,
    excludeTokensOfIndex,
  ): ITextLayerForPage | null => {
    if (!pdf) {
      return null;
    }

    const { pages } = pdf;

    const found = pages.find((p) => p.page === page);

    if (!found) {
      return null;
    }

    const { tokens: allTokens, text } = found;

    if (!allTokens.length) {
      return null;
    }

    let tokens = allTokens;

    if (excludeTokensOfEntityId) {
      tokens = getAvailableTokens(
        allTokens,
        annotations,
        page,
        excludeTokensOfEntityId,
        excludeTokensOfIndex,
      );
    }

    return {
      text: text.slice(0, allTokens[allTokens.length - 1].textEndIndex),
      tokens,
    };
  },
);

export default textLayerForPageSelector;
